// RITA-1504 (Nutzungserfassung Phase 2b) — Kopfsuche (Entwurf D).
//
// Beschreibt eine Suche in Zahlen: Länge der Eingabe, Trefferzahl und — falls etwas gewählt
// wurde — der Rang des gewählten Treffers (1-basiert, also die Position in der angezeigten
// Liste). Damit ist auswertbar, ob die Kopfsuche trifft (Auswahl weit oben) oder ob Menschen
// lange tippen und doch nichts finden.
//
// Der Suchtext und der gewählte Datensatz erreichen das Erfassungsmodul nie: die Schnittstelle
// nimmt ausschließlich Zahlen. Ohne Auswahl entfällt selected_rank (buildSearchProps lässt
// unbrauchbare Optionalzahlen entfallen, statt eine −1 zu melden).
import { buildSearchProps } from './usageProps';
import type { SearchProps } from './usageProps';

export interface SearchDescription {
  /** Länge der Eingabe — nie der Suchtext. */
  queryLength: number;
  /** Anzahl der angezeigten Treffer. */
  results: number;
  /** 1-basierte Position des gewählten Treffers; ohne Auswahl weglassen. */
  rank?: number;
}

export const describeSearch = ({ queryLength, results, rank }: SearchDescription): SearchProps =>
  buildSearchProps({ query_len: queryLength, results, selected_rank: rank });
